<template>
  <div class="ai-visibility-empty-state">
    <h2>{{ title }}</h2>
    <p v-if="description">{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-empty-state {
  border: 1px dashed var(--v-gray13Color-base);
  border-radius: 8px;
  background: var(--v-cardBg-base);
  color: var(--v-mainColor-base);
  padding: 28px;
  text-align: center;
}

.ai-visibility-empty-state h2 {
  font-size: 18px;
  font-weight: 800;
  margin: 0;
}

.ai-visibility-empty-state p {
  color: var(--v-mainColor3-base);
  font-size: 14px;
  line-height: 1.45;
  margin: 8px auto 0;
  max-width: 520px;
}
</style>
